<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="发送通知"
      @ok="handleSubmit"
    >
      <a-form
        class="custom-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <a-form-item label="通知类型">
          <a-select
            v-decorator="['notice_type',{
              rules: [ { required: true, message: '请选择通知类型' },]
            }]"
            @change="handleChangeNoticeType"
          >
            <a-select-option key="wear_armband" value="wear_armband">
              戴号提醒
            </a-select-option>
            <a-select-option key="first_night_watching" value="first_night_watching">
              第一夜守灵提醒
            </a-select-option>
            <a-select-option key="second_night_watching" value="second_night_watching">
              第二夜守灵提醒
            </a-select-option>
            <a-select-option key="prepare_provide_food" value="prepare_provide_food">
              贡菜供饭仪式提醒
            </a-select-option>
            <a-select-option key="location_box" value="location_box">
              奠盒仪式提醒
            </a-select-option>
            <a-select-option key="thankful_ceremony" value="thankful_ceremony">
              感恩仪式提醒
            </a-select-option>
            <a-select-option key="meal" value="meal">
              就餐提醒
            </a-select-option>
            <a-select-option key="funeral_ceremony" value="funeral_ceremony">
              告别出殡仪式提醒
            </a-select-option>
            <a-select-option key="other" value="other">
              其他环节提醒
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="环节名称" v-if="noticeType === 'other'">
          <a-input
            v-decorator="['node_name', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入环节名称' },
                { max: 20, message: '最多20个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item label="通知内容" v-if="noticeType !== 'other'">
          <a-textarea
            disabled
            v-decorator="['content', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入通知内容' },
                { max: 100, message: '最多100个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item :label="addressLabel" v-if="noticeType === 'meal' || noticeType === 'other'">
          <a-textarea
            v-decorator="['address', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: `请输入${addressLabel}` },
                { max: 20, message: '最多200个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item :label="startAtLabel">
          <a-date-picker
            style="width: 100%;"
            format="YYYY-MM-DD HH:mm"
            :show-time="{ format: 'HH:mm' }"
            @openChange="handleStartOpenChange"
            v-decorator="['start_at', {
              rules: [
                { required: true, message: `请选择${startAtLabel}` }
              ]
            }]"
          />
        </a-form-item>
        <a-form-item label="结束时间" v-if="isShowEndAt">
          <a-date-picker
            style="width: 100%;"
            @openChange="handleEndOpenChange"
            format="YYYY-MM-DD HH:mm"
            :show-time="{ format: 'HH:mm' }"
            v-decorator="['end_at', {
              rules: [
                { required: true, message: `请选择结束时间` }
              ]
            }]"
          />
        </a-form-item>

        <a-form-item label="发送目标">
          家属
        </a-form-item>
        <a-form-item label="通知方式">
          小程序、短信
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>

import { sendNotice } from '@/api/order'
import { formatMinuteTime } from '@/utils/time'

export default {
  name: 'SendNotice',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    serviceOrderId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'send_notice' }),
      submitting: false,
      data: {},
      noticeType: undefined,
      startAtLabel: '开始时间',
      addressLabel: '',
      isShowEndAt: true
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleStartOpenChange() {
      const fieldsValue = this.form.getFieldsValue()
      const startValue = fieldsValue.start_at
      const endValue = fieldsValue.end_at
      if (endValue && startValue) {
        if (endValue.valueOf() < startValue.valueOf()) {
          this.endOpen = false
          this.$warning({
            title: '结束时间不能小于开始时间',
            content: ''
          })
          this.form.setFieldsValue({ start_at: null })
        }
      }
    },
    handleEndOpenChange() {
      const fieldsValue = this.form.getFieldsValue()
      const startValue = fieldsValue.start_at
      const endValue = fieldsValue.end_at
      if (endValue && startValue) {
        if (endValue.valueOf() < startValue.valueOf()) {
          this.endOpen = false
          this.$warning({
            title: '结束时间不能小于开始时间',
            content: ''
          })
          this.form.setFieldsValue({ end_at: null })
        }
      }
    },

    handleChangeNoticeType(e) {
      this.noticeType = e
      this.startAtLabel = '开始时间'
      this.isShowEndAt = true
      this.form.setFieldsValue({ start_at: null, end_at: null, address: undefined })
      switch (e) {
        case 'wear_armband':
          this.startAtLabel = '戴号时间'
          this.isShowEndAt = false
          this.$nextTick(() => {
            this.form.setFieldsValue({
              content: '请主家与亲朋好友准备戴号',
              start_at: this.$moment(this.$moment().add(15, 'minutes').format('YYYY-MM-DD HH:mm'))
            })
          })
          return
        case 'first_night_watching':
        case 'second_night_watching':
          this.$nextTick(() => {
            this.form.setFieldsValue({
              content: '请主家与亲朋好友准备守灵',
              start_at: this.$moment(this.$moment().format('YYYY-MM-DD') + ' 22:30', 'YYYY-MM-DD HH:mm'),
              end_at: this.$moment(this.$moment().add(1, 'days').format('YYYY-MM-DD') + ' 06:30', 'YYYY-MM-DD HH:mm')
            })
          })
          return
        case 'prepare_provide_food':
          this.startAtLabel = '仪式时间'
          this.isShowEndAt = false
          this.$nextTick(() => {
            this.form.setFieldsValue({
              content: '请主家与亲朋好友准备进行贡菜供饭仪式',
              start_at: this.$moment(this.$moment().add(15, 'minutes').format('YYYY-MM-DD HH:mm'))
            })
          })
          return
        case 'location_box':
          this.$nextTick(() => {
            this.form.setFieldsValue({
              content: '请主家与亲朋好友准备进行奠盒仪式',
              start_at: this.$moment(this.$moment().add(15, 'minutes').format('YYYY-MM-DD HH:mm')),
              end_at: this.$moment(this.$moment().add(2, 'hours').format('YYYY-MM-DD HH:mm'))
            })
          })
          return
        case 'thankful_ceremony':
          this.$nextTick(() => {
            this.form.setFieldsValue({
              content: '请主家与亲朋好友准备进行感恩仪式',
              start_at: this.$moment(this.$moment().add(15, 'minutes').format('YYYY-MM-DD HH:mm')),
              end_at: this.$moment(this.$moment().add(2, 'hours').format('YYYY-MM-DD HH:mm'))
            })
          })
          return
        case 'meal':
          this.addressLabel = '就餐地点'
          this.$nextTick(() => {
            this.form.setFieldsValue({
              content: '请主家与亲朋好友准备就餐',
              start_at: this.$moment(this.$moment().add(15, 'minutes').format('YYYY-MM-DD HH:mm')),
              end_at: this.$moment(this.$moment().add(2, 'hours').format('YYYY-MM-DD HH:mm'))
            })
          })
          return
        case 'funeral_ceremony':
          this.$nextTick(() => {
            this.form.setFieldsValue({
              content: '请主家与亲朋好友准备进行告别出殡仪式',
              start_at: this.$moment(this.$moment().add(15, 'minutes').format('YYYY-MM-DD HH:mm')),
              end_at: this.$moment(this.$moment().add(2, 'hours').format('YYYY-MM-DD HH:mm'))
            })
          })
          return
        case 'other':
          this.addressLabel = '地点'
          this.$nextTick(() => {
            this.form.setFieldsValue({
              start_at: this.$moment(this.$moment().add(15, 'minutes').format('YYYY-MM-DD HH:mm')),
              end_at: this.$moment(this.$moment().add(2, 'hours').format('YYYY-MM-DD HH:mm'))
            })
          })
      }
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          const fieldsValue = this.form.getFieldsValue()
          const startValue = fieldsValue.start_at
          const endValue = fieldsValue.end_at
          if (startValue && endValue && startValue.valueOf() > endValue.valueOf()) {
            this.$message.error('结束时间不能大于开始时间')
            this.submitting = false
            return
          }
          const values = {
            ...fieldsValue,
            start_at: formatMinuteTime(fieldsValue.start_at),
            end_at: formatMinuteTime(fieldsValue.end_at)
          }

          sendNotice(this.serviceOrderId, values).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
